module.exports = __webpack_public_path__ + "static/media/citizen-logo-2025-cream.a4ab07b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/citizen-logo-2025-cream.svg
// module id = 365
// module chunks = 0